/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from 'react'
import {init as initFullStory} from '@fullstory/browser'
import {QueryClientProvider} from '@tanstack/react-query'
import ReactDOM from 'react-dom/client'
import {Provider} from 'react-redux'
import {PersistGate} from 'redux-persist/integration/react'
import 'react-toastify/dist/ReactToastify.css'

import Logger from 'services/Logger'
import './index.css'
import 'styles/Animations.css'
import {store, persistor} from 'app/store'
import App from 'app/App'
import reportWebVitals from './reportWebVitals'
import './i18n'
import {Router} from 'react-router-dom'
import {queryClient} from 'services/queryClient'

import SWR from './serviceWorkerRegistration'
import {PermissionsProvider} from 'rbac'
// NOTE: placing this import above app/store breaks the app - we'll need to figure this out
import {history} from 'utils'

Logger.init()

const nonDevelopmentFeatureFlag =
  process.env.REACT_APP_ENV !== 'development' &&
  process.env.REACT_APP_ENV !== 'test' &&
  process.env.REACT_APP_ENV !== 'deployment'

if (nonDevelopmentFeatureFlag) {
  SWR.register()
  // initialize fullstory
  initFullStory({
    orgId: process.env.REACT_APP_FS_ORG_ID as string,
    host: process.env.REACT_APP_FS_RELAY_HOST,
    script: `${process.env.REACT_APP_FS_RELAY_HOST}/s/fs.js`,
    appHost: 'app.fullstory.com',
  })
}

const reactContainerElement = document.getElementById('root') as HTMLElement
const rootContainer = ReactDOM.createRoot(reactContainerElement)

rootContainer.render(
  <React.StrictMode>
    {/* NOTE: once we stop using the history package, use BrowserRouter */}
    <Router history={history}>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <PersistGate persistor={persistor}>
            <PermissionsProvider>
              <App />
            </PermissionsProvider>
          </PersistGate>
        </QueryClientProvider>
      </Provider>
    </Router>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
